// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_wNS","cls2":"PackPreviewRows-cls2_bOk PackPreviewRows-cls1_wNS"};